// extracted by mini-css-extract-plugin
module.exports = {"button":"Login_button__3B3H1","buttonText":"Login_buttonText__1WlEs","icon":"Login_icon__3oBHG","loginLoadder":"Login_loginLoadder__3Xo5E"};